export function intersect_sets(a, b)   // result of sets a and b intersection
{
    res = new Set();
    for (var elem of a)
    {
        if (b.has(elem))
        {
            res.add(elem);
        }
    }
    return res;
}

export function is_intersect(a, b) // check whether sets a and b intersect
{
    for (var elem of a)
    {
        if (b.has(elem))
        {
            return true;
        }
    }
    return false;
}

export function is_positive_digits(value)
{
    return /^\d+$/.test(value);
}

export function is_positive_float(value)
{
    return !isNaN(value) && Number(value) > 0;
}

export function seconds_to_minutes_seconds(seconds) // takes int returns string
{
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`
}

export function num_to_signed(num)
{
    if (num < 0)
        return `${num}`;
    else
        return `+${num}`;
}

// data - Object, field - string
export function if_undefined(data, field, default_option)
{
   // console.log("if_undefined", data, field, default_option);
    return (field in data) ? data[field] : default_option;
}

export function imgPath(arg)
{
    return "/static/img/" + arg;
}
